import { getInstance } from '../index';
import { apiBaseUrl } from '../../utilities/api/apiHelper';
import { switchAPIVersion } from '../ApplicationService';

class Contact {
  constructor() {
    this.axios = getInstance();
  }

  async fetchAddressLookupByPostcode(postcode) {
    return await this.axios.get(
      `${apiBaseUrl}/backendforfrontend/address/lookup/${postcode}`,
      {}
    );
  }

  async fetchAddressLookupById(id) {
    return await this.axios.get(
      `${apiBaseUrl}/backendforfrontend/address/${id}`,
      {}
    );
  }

  async fetchValidateEmail(email) {
    return await this.axios.get(
      `${switchAPIVersion(
        apiBaseUrl,
        'v2'
      )}/backendforfrontend/validate/email?email=${email}`,
      {}
    );
  }
}

const contact = new Contact(getInstance());
export default contact;
